import { appMethod as app } from '@utils/app';

import './TabNavCustomComponent.less';

const turnToPage = (item, selectedRouter) => {
  if (item.router === selectedRouter) {
    return;
  }
  app.turnToPage(item.router);
}

export default function TabNavCustomComponent(props) {
  /**
   * 传入数据
   */ 
  const data = props.data;                    // 组件数据
  const customFeature = data.customFeature;   // 组件特性
  /**
   * 样式数据处理
   */
  const styleObj = {
    backgroundColor: customFeature.backgroundColor,
    borderColor: customFeature.borderStyle === 'black' ? '#d5d5d5' : customFeature.borderStyle,
  };
  /**
   * 组件内容处理
   */   
  const selectedRouter = props.match.url.substr(1);
  const content = data.content.map((item) => {
    if (item.router === selectedRouter) {
      item['imgUrl'] = item.selectedIconPath;           // 当前项：图片地址
      item['textColor'] = customFeature.selectedColor;  // 当前项：文本颜色
    } else {
      item['imgUrl'] = item.iconPath;
      item['textColor'] = customFeature.color;
    }
    return item;
  });
  const itemWidth = `${100 / content.length}%`;
  /**
   * 返回组件
   */ 
  return (
    <div className="custom-component tab-nav" style={styleObj}>
      {
        content.map((item, index) => (
          <div className="item" key={index} style={{ width: itemWidth}} onClick={() => turnToPage(item, selectedRouter)} >
            <div className="item-img">
              <img src={item.imgUrl} />
            </div>
            <div className="item-text" style={{color: item.textColor}}>{item.text}</div>
          </div>
        ))
      }
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/tab-nav-custom-component/TabNavCustomComponent.jsx